/**
 * Created by olga on 11.11.2024
 */

Unit.INTACT_ENABLED = false;
Unit.MULTY_CELL_BODY_OCCUPIED_CELL = false;
